import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/childcareLeave/index'

export const ChildcareLeaveRoutes: RouteParams[] = [
  {
    key: 'childcare_leave',
    path: WITH_AUTH_ADMIN_PATHS.CHILDCARE_LEAVE.INDEX,
    component: Index,
    exact: true,
  },
]
